<template>
  <div id="doctor-list">
    <div class="row topactionform">
      <div class="col-xs-5" style="padding-right: 0">
        <div class="smalltitle"> List <span style="text-transform: capitalize;">{{ type }}</span></div>
      </div>
      <div class="col-xs-7">
        <form class="onelineform flowsearch" @submit.prevent="getData()">
          <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
              class="fa fa-search"></i></button>
          <input type="text" placeholder="Name or leave blank for search all"
                 v-model="formSearch.keySearch"
                 class="keyinput" style="width: 50%; border-left: 1px solid #e1e1e1; float: right">
        </form>
      </div>
    </div>
    <div class="blockcont">
      <ul class="itemlisttable  ptemr-list">
        <li class="itemlisthead">
          <div class="item-name">Created At</div>
          <div class="item-dob">Create By</div>
          <div class="item-dob" style="width: 18%;">Url</div>
          <div class="item-created-at" style="width: 22% !important; text-align: left !important;">Title</div>
          <div class="item-clinic" style="text-align: left !important;width: 25% !important;">Description</div>
          <div class="item-action" style="text-align: left !important;width: 5% !important;">Action</div>
        </li>
        <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
            class="fas fa-spinner fa-spin"></i></li>
        <li v-if="!isLoading && dataPosts.length === 0" style="text-align: center; font-size: 16pt">
          No records found
        </li>
        <li v-if="!isLoading" class="item-doctor" v-for="(post, index) in dataPosts">
          <div class="item-name" @click="showDetailUser(doctor)" @click.prevent="showInfoSeo(post)">
            {{ formatTime(post.createdAt) }}
          </div>
          <div class="item-dob" @click.prevent="showInfoSeo(post)">
            <span v-if="post.user">{{ post.user.fullName }}</span>
          </div>
          <div class="item-dob" style="width: 18%;">
            <a :href="getLink(post)" target="_blank">{{ getLink(post) }}</a>
          </div>
          <div @click.prevent="showInfoSeo(post)" class="item-created-at" style="width: 22% !important; min-height: 1px !important; text-align: left !important;">{{ post.title }}</div>
          <div @click.prevent="showInfoSeo(post)" class="item-clinic" style="text-align: left !important;width: 25% !important; min-height: 1px;">{{ post.content }}</div>
          <div @click.prevent="removePost(post)" class="item-clinic" style="text-align: left !important;width: 5% !important;">Remove</div>
        </li>
      </ul>
    </div>
    <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                :totalPages="paginate.totalPages" :total="paginate.total"></pagination>

    <modal name="form_task" v-model="post.modal" size="lg" :backdrop="false" @hide="hideTaskForm()">
      <div slot="title">Seo Info</div>
      <div>
        <div class="prolabel note">Keyword</div>
        <div class="profield">
          <textarea v-model.trim="post.keyWordSeo"></textarea>
        </div>
        <div class="prolabel note">Title</div>
        <div class="profield">
          <textarea v-model.trim="post.titleSeo"></textarea>
        </div>
        <div class="prolabel note">Description</div>
        <div class="profield">
          <textarea v-model.trim="post.descriptionSeo"></textarea>
        </div>
      </div>
      <div slot="footer">
        <button type="button" class="btn btn-default" @click.prevent="updateSeo()"><i
            v-if="post.isUpdateSeo" class="fas fa-spinner fa-spin"></i> Save
        </button>
      </div>
    </modal>
</div>
</template>

<script>
import axios from '@/client'
import Common from '@/components/mixins/Common.vue'
import httpClient from '../../client'
import Pagination from '../../global/Pagination.vue'
import config from '../../config'
const wikiUrl = config.wikiUrl
export default {
  name: 'Main',
  mixins: [Common],
  components: {
    Pagination
  },
  data () {
    return {
      dataList: [],
      type: 'newsfeed',
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      dataPosts: [],
      formSearch: {
        keySearch: ''
      },
      post: {
        modal: false,
        id: '',
        keyWordSeo: '',
        titleSeo: '',
        descriptionSeo: '',
        isUpdateSeo: false
      }
    }
  },
  computed: {
  },
  mounted () {
    let routeName = this.$route.name
    let routeNames = routeName.split('-')
    this.type = routeNames[1]
    this.getData()
  },
  methods: {
    async getData () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch,
        typePage: this.type
      }
      let response = await httpClient.get(`/seo/list-post`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          this.dataPosts = response.data.data.posts ? response.data.data.posts : []
          this.paginate.page = Number(response.data.data.currentPage)
          this.paginate.total = response.data.data.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    showInfoSeo (item) {
      this.post.id = item.id
      this.post.keyWordSeo = item.keyWordSeo ? item.keyWordSeo : ''
      this.post.titleSeo = item.titleSeo ? item.titleSeo : ''
      this.post.descriptionSeo = item.titleSeo ? item.descriptionSeo : ''
      this.post.isUpdateSeo = false
      this.post.modal = true
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.getData()
    },
    updateSeo () {
      if (!this.post.isUpdateSeo) {
        this.post.isUpdateSeo = true
        const vm = this
        axios.post(`/seo/update-post`, {
          typePage: this.type,
          id: this.post.id,
          keyWordSeo: this.post.keyWordSeo,
          titleSeo: this.post.titleSeo,
          descriptionSeo: this.post.descriptionSeo
        }).then(response => {
          this.post.isUpdateSeo = false
          let data = response.data
          if (data.s === 200) {
            let index = this.dataPosts.findIndex(item => item.id == this.post.id)
            this.dataPosts[index].keyWordSeo = this.post.keyWordSeo
            this.dataPosts[index].titleSeo = this.post.titleSeo
            this.dataPosts[index].descriptionSeo = this.post.descriptionSeo
            this.hideTaskForm()
          } else {
            this.post.msg = data.s.msg
          }
        }).catch(e => {
          this.post.msg = e.message
        })
      }
    },
    hideTaskForm () {
      this.post = {
        modal: false,
        id: '',
        keyWordSeo: '',
        titleSeo: '',
        descriptionSeo: '',
        isUpdateSeo: false
      }
    },
    getLink (post) {
      if (this.type == 'newsfeed') {
        let title = post.title.toLowerCase()
          .replace(/ /g, '-')
          .replace(/[^\w-]+/g, '')
        return `${wikiUrl}/post-${title}-${post.id}`
      }
      if (this.type == 'question') {
        let title = post.content.substring(0, 15).toLowerCase()
          .replace(/ /g, '-')
          .replace(/[^\w-]+/g, '')
        return `${wikiUrl}/ask-${title}-${post.id}`
      }
    },
    removePost (post) {
      console.log('postssss', post)
      let titleDiablog = 'Are you sure you want to remove ' + this.type + ' from ' + post.user.fullName
      if (this.type == 'question') {
        titleDiablog += ' from Ask the Allergist/Ask the Doctor page'
      }
      titleDiablog += '?'
      this.$confirm({
        title: 'Confirm',
        content: titleDiablog
      }).then(() => {
        axios.post(`/seo/remove-post`, {
          typePage: this.type,
          id: post.id,
        }).then(response => {
          let data = response.data
          if (data.s === 200) {
            let index = this.dataPosts.findIndex(item => item.id == post.id)
            this.dataPosts.splice(index, 1)
            this.alertSuccess('Post removed successfully')
          } else {
            this.alertError('Failed to remove post')
          }
        }).catch(e => {
          this.alertError('Error occurred while removing post')
        })
      })
    },
  }
}
</script>

<style scoped>

</style>
